import { css } from '@emotion/react';

import CreditApplicationPageLayout from 'src/components/creditApplication/CreditApplicationPageLayout';
import GetHelpTextButton from 'src/components/creditApplication/GetHelpTextButton';

const ApplicationReviewPage = () => {
  return (
    <CreditApplicationPageLayout
      showLogo={false}
      icon='Hourglass24'
      title='Your application needs to be&nbsp;reviewed'
      subtitle='Our team will get back to you as soon as possible. Response times may be delayed during peak and off-hours.'
    >
      <div css={root}>
        <GetHelpTextButton />
      </div>
    </CreditApplicationPageLayout>
  );
};

const root = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-top: 24px;
  text-align: center;
`;

export default ApplicationReviewPage;
